import { shortFormsEnabled } from '../../../brand/tenant';

// ÐÐ½ÐºÐµÑÐ° ÑÐµÑÐ¾Ð³Ð¾ Ð´Ð¸Ð»ÐµÑÐ°: Ð¿Ð»Ð°ÑÑÐ¶ Ð²ÑÐµÐ³Ð´Ð° Ð°Ð½Ð½ÑÐ¸ÑÐµÑÐ½ÑÐ¹, Ð´ÐµÐ½Ñ Ð¿Ð¾Ð³Ð°ÑÐµÐ½Ð¸Ñ â Ð´ÐµÐ½Ñ Ð¿Ð¾Ð´Ð°ÑÐ¸ Ð·Ð°ÑÐ²ÐºÐ¸.
// ÐÐ¾Ð»Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÑ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ â Ð¿Ð¾Ð´ÑÑÐ°Ð²Ð»ÑÐµÐ¼ Ð¿ÑÐ¸ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐµ.
export const ANNUITY_REPAYMENT_TYPE = 0;

// ÐÐ°Ð½ÐºÐ¸ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÑÑ Ð´ÐµÐ½Ñ Ð¿Ð¾Ð³Ð°ÑÐµÐ½Ð¸Ñ ÑÐ¾Ð»ÑÐºÐ¾ Ñ 1 Ð¿Ð¾ 23 (ÑÐ° Ð¶Ðµ Ð³ÑÐ°Ð½Ð¸ÑÐ° Ð² Ð¿ÑÐ¾Ð²ÐµÑÐºÐµ Ð¿Ð¾Ð»Ñ Ð°Ð½ÐºÐµÑÑ).
export const MAX_REPAYMENT_DAY = 23;

export const repaymentDayOf = (date = new Date()) => Math.min(date.getDate(), MAX_REPAYMENT_DAY);

export const REPAYMENT_FIELDS = ['repaymentType', 'repaymentDay'];

export const withoutRepaymentFields = (inputs, short = shortFormsEnabled()) =>
  short ? inputs.filter((input) => !REPAYMENT_FIELDS.includes(input.name)) : inputs;

// ÐÐ°Ð»Ð¾ÑÐºÐ¸ Ð°Ð½ÐºÐµÑÑ (ÑÑÐ±ÑÐ¸Ð´Ð¸Ñ, ÑÐ°ÑÑÑÐ¾ÑÐºÐ°, Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð°Ñ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ñ, Ð»ÑÐ³Ð¾ÑÐ½Ð¾Ðµ ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ðµ) ÑÐµÑÑÐ¼ Ð½Ðµ Ð½ÑÐ¶Ð½Ñ:
// Ð¸Ñ Ð½ÐµÑ Ð½Ð° ÑÐºÑÐ°Ð½Ðµ, Ð¸ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð¸Ð· ÑÑÐ°ÑÐ¾Ð³Ð¾ ÑÐµÑÐ½Ð¾Ð²Ð¸ÐºÐ° Ð² Ð·Ð°ÑÐ²ÐºÑ Ð½Ðµ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÑÑ.
export const flagFromDraft = (value, short = shortFormsEnabled()) => !short && !!value;

// Ð¡ÑÐ°ÑÑÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ°, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð¾ÑÑÐ°ÑÑÑÑ Ñ ÑÐµÑÑÑ: Ð¾Ð±ÑÑÐ½ÑÐ¹ (ÐÐ¦ÐÐ), Ñ Ð²ÑÐ¿Ð¸ÑÐºÐ¾Ð¹ ÐÐÐ£, Ð²Ð¾ÐµÐ½Ð½Ð¾ÑÐ»ÑÐ¶Ð°ÑÐ¸Ð¹.
export const GREY_WORK_STATUS_IDS = ['0', '9', '3'];

export const workStatusOptions = (options, short = shortFormsEnabled()) =>
  short ? options.filter((option) => GREY_WORK_STATUS_IDS.includes(String(option.value))) : options;

// Ð§ÑÐ¾ ÑÑÐ¾Ð´Ð¸Ñ Ð² Ð·Ð°ÑÐ²ÐºÑ Ð²Ð¼ÐµÑÑÐ¾ ÑÐºÑÑÑÑÑ Ð¿Ð¾Ð»ÐµÐ¹.
export const repaymentPayload = (values, short = shortFormsEnabled(), date = new Date()) =>
  short
    ? { repaymentType: ANNUITY_REPAYMENT_TYPE, repaymentDay: repaymentDayOf(date) }
    : {
        repaymentType: values?.repaymentType?.value,
        repaymentDay: values?.repaymentDay ? +values?.repaymentDay?.replace(/\s/g, '') : 0,
      };
